import { Button, Stack } from '@mui/material';
import IconStatusButton from '../../../../../common-components/icon-status-button/icon-status-button';

interface SelectDeselectProPdfDownloadActionGroupProps {
  onCancel: () => void;
  onClick: () => void;
  statusIcon: React.ReactNode;
  statusText: string;
  tooltipContent: React.ReactNode;
  disabled: boolean;
}

function SelectDeselectProPdfDownloadActionGroup({
  onCancel,
  onClick,
  statusIcon,
  statusText,
  tooltipContent,
  disabled,
}: SelectDeselectProPdfDownloadActionGroupProps) {
  return (
    <Stack
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'stretch',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 1,
        width: '100%',
      }}
      data-testid="select-deselect-action-group"
    >
      <Button
        onClick={onCancel}
        variant="outlined"
        sx={{ flexGrow: 1, minWidth: '47.5%' }}
        data-testid="delete-group-cancel-button"
      >
        Cancel
      </Button>
      <IconStatusButton
        tooltipContent={tooltipContent}
        onClick={onClick}
        statusIcon={statusIcon}
        statusText={statusText}
        dataTestId="pro-report-download-button"
        ariaLabel="Download PRO report"
        sx={{ flexGrow: 1, minWidth: '47.5%' }}
        disabled={disabled}
      />
    </Stack>
  );
}

export default SelectDeselectProPdfDownloadActionGroup;
